import { useMemo } from 'react';
import { useConfig } from '../../../../eliot-components/src/ConfigProvider/hooks';
import { MedisanteDevice } from '../../../../pages/Device/types';
import { getAllGatewayIds } from '../DeviceLinking/provider';
import { useGetDevicesByIdQuery } from '../../../../store/api-slice';

export const useGateways = (devices: MedisanteDevice[]) => {
  const config = useConfig();
  const gatewayIds = getAllGatewayIds(devices);
  const {
    data: gateways = [],
    error,
    isFetching: isLoading,
  } = useGetDevicesByIdQuery({
    apiBaseURL: config.apiBaseURL,
    ids: gatewayIds,
  });

  const result = useMemo(
    () => ({
      gateways,
      error,
      isLoading,
    }),
    [gateways, error, isLoading]
  );

  return result;
};
